import React from 'react';
import styles from '../command-palette.scss';
import { SearchIcon } from '@qualtrics/ui-react/icons';
import PropTypes from 'prop-types';

export const CommandPaletteSearchHeader = React.forwardRef(
  ({ search, setSearch, onKeyDown }, ref) => {
    return (
      <div className={styles.commandPaletteSearch}>
        <div className={styles.searchContent}>
          <div className={styles.searchIcon}>
            <SearchIcon aria-hidden />
          </div>
          <input
            ref={ref}
            type="text"
            placeholder="Search Qualtrics"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={onKeyDown}
            className={styles.searchInput}
          />
        </div>
        <div className={styles.keyboardShortcuts}>
          <span className={styles.keyboardKey}>⌘</span>
          <span className={styles.keyboardKey}>K</span>
        </div>
      </div>
    );
  },
);

CommandPaletteSearchHeader.displayName = 'CommandPaletteSearchHeader';
CommandPaletteSearchHeader.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
};
